"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimestampsSchema = void 0;
exports.createTimestamps = createTimestamps;
exports.updateTimestamp = updateTimestamp;
const zod_1 = require("zod");
exports.TimestampsSchema = zod_1.z.object({
    createdAt: zod_1.z.number().describe('Unix timestamp in milliseconds'),
    updatedAt: zod_1.z.number().describe('Unix timestamp in milliseconds'),
});
function createTimestamps() {
    const now = Date.now();
    return { createdAt: now, updatedAt: now };
}
function updateTimestamp() {
    return { updatedAt: Date.now() };
}
//# sourceMappingURL=timestamps.schema.js.map